function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5 2.5L11.5 1.5L7.5 3.5V22.5L4 23L1.5 25V38L7.5 44.5V48.5H28V45.5L32.5 38V19.5L14.5 13.5V2.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.3625 13.6231L32.9712 18.768V37.3912L28.1886 44.6376V48.9129",
  stroke: "#6C8936",
  strokeWidth: 2.17391,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.31892 48.9128V44.6374L1.08704 37.3911",
  stroke: "#6C8936",
  strokeWidth: 2.17391,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.68127 28.4058V4.71019C7.68127 2.68121 9.27548 1.08701 11.3045 1.08701C13.3334 1.08701 14.9277 2.68121 14.9277 4.71019V21.9566",
  stroke: "#6C8936",
  strokeWidth: 2.17391,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.942 15.2174V23.6957",
  stroke: "#6C8936",
  strokeWidth: 2.17391,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.9567 25.5073V17.029",
  stroke: "#6C8936",
  strokeWidth: 2.17391,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.08704 37.3912V27.3187C1.08704 24.3477 3.47834 21.9564 6.44935 21.9564H7.68124",
  stroke: "#6C8936",
  strokeWidth: 2.17391,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H34.058V50H0V0Z",
  fill: "white"
})));

function SvgTouchControlSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 50,
    viewBox: "0 0 35 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouchControlSelect);
export default __webpack_public_path__ + "static/media/touch-control-select.c84f3c1b.svg";
export { ForwardRef as ReactComponent };